import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

const ROTATIONS = [
  'rotate-0',
  'rotate-90',
  'rotate-180',
  'rotate-270',
]

export default class extends Controller {
  static targets = [
    'dialog',
    'image',
    'imageContainer',
    'viewport',
  ]

  connect() {
    useClickOutside(this, { element: this.imageContainerTarget })
    this.rotationIndex = 0
  }

  applyRotation() {
    this.imageTarget.classList.remove(...ROTATIONS)
    this.imageTarget.classList.add(ROTATIONS[this.rotationIndex])

    if (!this.imageTarget.complete) return

    const isSideways = this.rotationIndex % 2 === 1
    const width = this.imageTarget.clientWidth
    const height = this.imageTarget.clientHeight

    this.viewportTarget.style.width = `${isSideways ? height : width}px`
    this.viewportTarget.style.height = `${isSideways ? width : height}px`
  }

  clickOutside() {
    this.close()
  }

  close() {
    this.dialogTarget.close()
  }

  imageLoaded() {
    this.applyRotation()
  }

  open({ params: { url } }) {
    if (!url) return

    this.resetRotation()
    this.imageTarget.src = url
    this.dialogTarget.showModal()
  }

  print() {
    if (!this.dialogTarget.open || !this.imageTarget.src) return

    const printWindow = window.open('', '_blank')

    if (!printWindow) return

    const image = printWindow.document.createElement('img')
    image.src = this.imageTarget.src
    image.alt = this.imageTarget.alt
    image.style.maxWidth = '100%'

    image.addEventListener(
      'load',
      () => {
        printWindow.focus()
        printWindow.print()
        printWindow.close()
      },
      { once: true },
    )

    printWindow.document.body.append(image)
  }

  reset() {
    this.imageTarget.removeAttribute('src')
    this.resetRotation()
  }

  resetRotation() {
    this.rotationIndex = 0
    this.applyRotation()
  }

  rotateLeft() {
    if (!this.dialogTarget.open) return

    this.rotationIndex =
      (this.rotationIndex - 1 + ROTATIONS.length) % ROTATIONS.length

    this.applyRotation()
  }

  rotateRight() {
    if (!this.dialogTarget.open) return

    this.rotationIndex = (this.rotationIndex + 1) % ROTATIONS.length

    this.applyRotation()
  }
}
